const styles = {
  container: {
    textAlign: 'center',
    fontFamily: '"Playfair Display", serif',
    backgroundColor: '#111',
    padding: '20px 10px',
    minHeight: '100vh',
    color: '#fff',
    overflowX: 'hidden',
  },
  uiPanel: {
    background: 'rgba(30, 30, 30, 0.95)',
    padding: '20px',
    borderRadius: '16px',
    border: '1px solid #d4af37',
    maxWidth: '800px',
    margin: '0 auto 20px',
    display: 'flex',
    gap: '12px',
    justifyContent: 'center',
    flexWrap: 'wrap',
  },
  canvasArea: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    overflow: 'hidden',
    margin: '20px 0',
    position: 'relative',
  },
  wrapper: {
    width: '500px',
    height: '700px',
    flexShrink: 0,
    background: 'linear-gradient(145deg, #2c1608 0%, #3d1f0d 50%, #1a0d05 100%)',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '40px',
    border: '1px solid #4e2c1c',
    transformOrigin: 'top center',
  },
  inputText: {
    padding: '12px',
    borderRadius: '4px',
    border: '1px solid #d4af37',
    background: '#000',
    color: '#fff',
    width: '100%',
    maxWidth: '250px',
  },
  inputFile: {
    color: '#d4af37',
    paddingTop: '10px',
  },
  customEventInput: {
    padding: '10px',
    width: '100%',
    maxWidth: '400px',
    borderRadius: '4px',
    border: '1px solid #d4af37',
    background: '#000',
    color: '#fff',
    marginBottom: '15px',
  },
  buttonOrder: {
    padding: '15px 40px',
    background: '#f97316',
    color: '#fff',
    border: 'none',
    fontWeight: '900',
    cursor: 'pointer',
    borderRadius: '4px',
    textTransform: 'uppercase',
    width: '100%',
    maxWidth: '300px',
  },
  orderStatus: {
    marginTop: '15px',
    color: '#f9d976',
    fontWeight: '700',
    width: '100%',
  },
  title: {
    color: '#d4af37',
    fontSize: '2.2rem',
    marginBottom: '5px',
    fontFamily: 'Cinzel',
    fontWeight: 900,
  },
  subtitle: {
    opacity: 0.6,
    marginBottom: '20px',
    letterSpacing: '2px',
    fontSize: '0.9rem',
  },
  eventOptionsContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    gap: '15px',
    margin: '10px 0',
    flexWrap: 'wrap',
  },
  eventOptionLabel: {
    cursor: 'pointer',
    fontSize: '0.85rem',
    // color: '#d4af37',
        color: '#f9d976',

    display: 'flex',
    alignItems: 'center',
    gap: '5px',
  },
  topText: {
    fontFamily: 'Cinzel',
    // color: '#d4af37',
        color: '#f9d976',

    fontSize: '2.5rem',
    fontWeight: 700,
    textAlign: 'center',
    marginTop: '30px',
    zIndex: 11,
    textShadow: '3px 3px 6px rgba(0,0,0,0.7)',
  },
  photoContainerWrapper: {
    marginTop: '40px',
    position: 'relative',
    zIndex: 11,
    padding: '15px',
    background: 'linear-gradient(45deg, #a67c00, #f9d976, #a67c00)',
    borderRadius: '50%',
    boxShadow: '0 15px 40px rgba(0,0,0,0.8)',
  },
  photoContainerInner: {
    width: '260px',
    height: '260px',
    borderRadius: '50%',
    overflow: 'hidden',
    border: '5px solid #2c1608',
    background: '#2c1608',
    position: 'relative',
  },
  nameSection: {
    marginTop: '40px',
    zIndex: 11,
    textAlign: 'center',
  },
  recipientName: {
    fontFamily: 'Playfair Display',
    fontSize: '3.8rem',
    fontWeight: '900',
    color: '#f9d976',
    lineHeight: '1',
    textShadow: '2px 4px 10px rgba(0,0,0,0.9)',
  },
  customFileUpload: {
    display: "inline-block",
    padding: "10px 20px",
    backgroundColor: "#6d6875",
    color: "#fff",
    borderRadius: "8px",
    cursor: "pointer",
    fontWeight: "500",
    letterSpacing: "1px",
    transition: "0.3s ease",
  },
};

export default styles;
